module.exports = __webpack_public_path__ + "c8e5638dd7ac5acc3a2ca102f360abbc.png";